/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the report table component
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

import { DataTable, IDataTableProps } from '@ngt/online-patient-management-ui';
import * as React from 'react';
import { IReportParam, ReportExportFormat } from '../../utilities/createReportUrl';

/*
 * ---------------------------------------------------------------------------------
 * Types
 * ---------------------------------------------------------------------------------
 */

export type GetReportParamsFunction = () => IReportParam[];

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

interface IReportTableProps<Type extends object = any> extends IDataTableProps<Type> {

}

export interface IReportItem {
    reportTitle: string;
    reportFile: string;
    reportFormat?: ReportExportFormat;
    reportParams: IReportParam[];
    access: string;
}

const ReportTable = <Type extends object>({
    data,
    ...tableProps
}: IReportTableProps<Type>) => {
    return (
        <>
            <DataTable
                data={data}
                {...tableProps}
            />
        </>
    );
};

export default ReportTable;